<template>
  <div
    class="sensor-decoder"
    :class="{'sensor-decoder--disabled': sensorData.data.disable, 'sensor-decoder--options': sensorData.relations.length}"
  >
    <div
      class="sensor-decoder__wrapper"
      :title="sensorData.data.disable ? $t('messages.sensors.sensorDisabled') : null"
    >
      <button
        v-if="computedCanEdit"
        class="sensor-decoder__edit-button g-btn"
        @click.stop="editClicked()"
      >
        {{ $t('messages.sharedTexts.controls.edit') }}
      </button>

      <div class="sensor-decoder__information">
        <div
          class="sensor-decoder__information__item"
        >
          {{ sensorData.data.sdname }}
        </div>
        <div
          class="sensor-decoder__information__item"
          :class="{'sensor-decoder__information__item--active': hasAlarms}"
          :title="$t('messages.sensors.alarmHelp')"
        >
          <font-awesome-icon :icon="['fas', 'bell']" />
        </div>
        <div
          class="sensor-decoder__information__item"
          :class="{'sensor-decoder__information__item--active': hasActions}"
          :title="$t('messages.sensors.actionHelp')"
        >
          <font-awesome-icon :icon="['fas', 'cogs']" />
        </div>
      </div>

      <div class="sensor-decoder__body">
        <h4
          v-show="computedtype"
          class="g-title g-title--subtitle sensor-decoder__type"
        >
          {{ computedtype }}
        </h4>

        <p class="g-title g-title--subtitle sensor-decoder__description">
          {{ sensorData.data.description }}
        </p>
      </div>
    </div>

    <expanding-information
      v-if="sensorData.relations.length"
      ref="expandingInformation"
      class="sensor-decoder__options"
      :show ="false"
      @change="updateLayout($event)"
    >
      <div class="expanding-information__row sensor-decoder__options__row">
        <div
          v-for="key in computedRelationKeys"
          :key="key"
        >
          <h6>{{ key }}</h6>
        </div>
      </div>

      <div
        v-for="relation in sensorData.relations"
        :key="relation.sdname"
        class="expanding-information__row sensor-decoder__options__row"
      >
        <span>{{ relation.sdname }}</span>
        <span>{{ Math.sign(relation.globalsum) > 0 ? '+' : '-' }}</span>
        <span>{{ getEllipsis(relation.description) }}</span>
      </div>
    </expanding-information>
  </div>
</template>

<script>
import $ from 'jquery'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import{MicroService} from '@/assets/javascript/mixins/Mixins'
import ExpandingInformation from '@/components/elements/ExpandingInformation'

export default {
  name: 'SensorDecoderComponent',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'expanding-information': ExpandingInformation
  },
  mixins: [MicroService],
  props: {
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    sensorData: {
      type: Object,
      default() {
        return {}
      }
    },
    types: {
      type: Array,
      default() {
        return []
      }
    },
    store: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      hasAlarms: false,
      hasActions: false,
      optionsShow: false
    }
  },
  computed: {
    computedCanEdit() {
      return this.store.getData('user.access.sensorDecoderEdit')
    },
    computedRelationKeys() {
      return this.sensorData.relations && this.sensorData.relations.length
      ? Object.keys(this.sensorData.relations[0]).map(key => this.$t(`messages.sensors.sdSetup.${key}`))
      : []
    },
    computedtype() {
      if(!(this.types && this.types.length)) return 'N/A'
  
      return this.types.find(type => type.enum === this.sensorData.data.senstype).lang
    },
    computedValue() {
      return this.sensorData && this.sensorData.data.value ? this.sensorData.data.value : '-'
    }
  },
  watch: {
    PageMessage({target, command, data}) {
      if(target === 'sensors')
        console.log(JSON.stringify(data))
        if(command === 'updateInformation') this.getInformation()
    }
  },
  mounted() {
    this.$emit('sensorLoaded', this.sensorData.data.id)
    this.getInformation()
  },
  methods: {
    getEllipsis(str, cutAt = 15) {
      let rtn =  str.substring(0, cutAt)

      if(cutAt < str.length) rtn = rtn + '...'

      return rtn
    },
    updateLayout(show) {
      let $componentEl = $(this.$el)

      console.log($componentEl, $(this.$refs.expandingInformation.$el).outerHeight())

      show
      ? $componentEl.css({marginBottom: $(this.$refs.expandingInformation.$el).height()})
      : $componentEl.css({marginBottom: 0})

      console.log(show)

      this.$emit('reload-layout')
    },
    editClicked() {
      if(!this.computedCanEdit) return

      this.$emit('openSensorEdit', this.sensorData)
    },
    getInformation() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdsubinformation?ctrlid=${this.sensorData.data.ctrlid}&id=${this.sensorData.data.id}`
      })
      .then((response) => {
        if(response.data) {
          const data = response.data.getsdsubinformation[0]
          this.hasAlarms = data.alarms
          this.hasActions = data.actions
        } else
          console.error('no data for getsdsubinformation')
      }).catch(console.error)
    }
  }
}
</script>

<style lang="scss">
.sensor-decoder {
  $color: darken($color-grey-dark, 10);
  position: relative;
  width: 225px;

  &--disabled {
    opacity: 0.65;
    cursor: help;
  }

  &__options {
    top: calc(100% - 1px);
    box-shadow: none;
    font-size: 11px;
    text-align: center;

    h6 {
      font-size: 9px;
      margin: 0;
    }
    &__row {
      box-sizing: border-box;
      width: 100%;
      display: grid;
      grid-template-columns: 50px 65px 1fr;
      margin: 0;
      border: 1px solid $color-grey;
      border-bottom: 0;
      border-right: 0;
      &:not(:first-child) {
        border-top: 0;
      }

      > * {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 5px;
        border: 1px solid $color-grey;
        border-top: 0;
        border-left: 0;
        margin-right: -1px;
        margin-bottom: -1px;
      }
    }
  }

  &__wrapper {
    box-sizing: border-box;
    border: 1px solid $color-grey;
    background-color: $color-white;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 87px;

    border-top-left-radius: $application-base-border-radius;
    border-bottom-left-radius: $application-base-border-radius;
    border-bottom-right-radius: $application-base-border-radius;

    .sensor-decoder--options & {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  &__edit-button {
    position: absolute;
    bottom: calc(100% - 1px);
    right: -5px;
    box-sizing: border-box;
    border-color: $color-grey !important; // TODO: no !important
    border-top-right-radius: $application-base-border-radius;
    border-top-left-radius: $application-base-border-radius;
    margin: 0 5px 0;
  }

  &__information {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border-right: 1px solid $color;
    font-size: 18px;

    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 5px;
      cursor: help;

      &:nth-child(1) {
        grid-column: 1 / span 2;
      }
      &:nth-child(2) {
        border-top: 1px solid $color;
        border-right: 1px solid $color;
      }
      &:nth-child(3) {
        border-top: 1px solid $color;
        margin-left: -1px;
      }

      &--active {
        color: green;
      }
    } 
  }

  &__body {
    display: flex;
    flex-direction: column;
    padding: 0 5px 5px;
    overflow: hidden;

    > * {
      line-height: 22px;
    }
  }

  &__relations {
    margin: 5px 0 0;
    padding: 2px;
    font-size: 11px;
    width: 100%;
  }

  &__name {
    font-family: $font-primary-semibold;
    white-space: nowrap;
    margin: 0;
    text-overflow: ellipsis;
  }
  &__type {
    font-family: $font-primary-medium;
    white-space: nowrap;
    margin: 5px 0 0;
    text-overflow: ellipsis;
    font-size: 11px;
    line-height: 11px;
  }
  &__description {
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: $font-primary;
    margin: 5px 0 0;
    font-size: 11px;
    line-height: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    flex-grow: 1;
  }
}
</style>
